/**
 * @format
 * @module lib/financial/press-releases
 */
import { qsa } from "utils/utils";

/**
 * @method init
 * @description Appends a trailing slash to links within the Barchart "latest press releases" module
 * @see https://www.theglobeandmail.com/investing/markets/stocks/AAPL-Q/
 */
export default function init() {
  const links = qsa(
    ".page-or-template-stock-quote .o-financial-widget-wrapper__card .news-stories .story-container a"
  );
  links.forEach(link => {
    const href = link.getAttribute("href");
    if (href && !href.endsWith("/")) {
      link.setAttribute("href", `${href}/`);
    }
  });
}
